import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { FolderMinus } from 'lucide-react';

import { EmptyState, EmptyStateCircles, EmptyStateContent, EmptyStateDescription, EmptyStateTitle } from '@/components/ui/empty-state';
import { FeaturedIcon } from '@/components/ui/featured-icon';
import { Skeleton } from '@/components/ui/skeleton';

export function DirectoryListEmpty(directoryListEmptyProps: ComponentProps<'li'>) {
  const { className, ...props } = directoryListEmptyProps;
  return (
    <li className={className} {...props}>
      <EmptyState className="p-6">
        <EmptyStateCircles className={'z-0'} />
        <FeaturedIcon size={'lg'} className={'z-10'}>
          <FolderMinus />
        </FeaturedIcon>
        <EmptyStateContent>
          <EmptyStateTitle>Brak plików/folderów</EmptyStateTitle>
          <EmptyStateDescription>Brak plików i/lub folderów w wybranej lokalizacji.</EmptyStateDescription>
        </EmptyStateContent>
      </EmptyState>
    </li>
  );
}

export function DirectoryListPending(directoryListPendingProps: ComponentProps<'li'>) {
  const { className, ...props } = directoryListPendingProps;
  return (
    <>
      {Array.from({ length: 5 }).map((_, i) => (
        <li key={i} className={cn('flex h-13.5 items-center gap-2 p-2', className)} {...props}>
          <Skeleton className="size-7 rounded-sm" />
          <Skeleton className="h-4 w-full max-w-24 rounded-sm" />
        </li>
      ))}
    </>
  );
}
